import { request } from './request'

export const getList = data => {
  const url = '/api/v1/maps'
  return request({
    method: 'get',
    url: url,
    params: data
  })
}

export const setMapItem = data => {
  const url = '/api/v1/maps'
  return request({
    method: 'post',
    url: url,
    data: data
  })
}
export const getListItem = data => {
  const url = `/api/v1/maps/${data.id}`
  return request({
    method: 'get',
    url: url
  })
}

export const getSiteMapsByIds = ids => {
  const url = '/api/v1/maps/getMapsByIds'
  return request({
    method: 'get',
    url: url,
    params: { ids }
  })
}

export const getPubDomains = () => {
  const url = '/api/v1/merchant/pub-domains'
  return request({
    method: 'get',
    url
  })
}

export const getDomains = () => {
  return request({
    method: 'get',
    url: '/api/v1/sitemap/domain'
  })
}

export const putDomainsList = data => {
  const url = '/api/v1/sitemap/update'
  return request({
    method: 'put',
    url: url,
    data
  })
}
